import parser from 'fast-xml-parser'

/**
 * Parse a single BGG /collection XML response body into item objects.
 * @param {string} xmlString
 * @returns {object[]}
 */
export function parseCollectionItemsFromXmlString(xmlString) {
	if (xmlString == null || typeof xmlString !== 'string') return []
	let parsed
	try {
		parsed = parser.parse(xmlString, { ignoreAttributes: false })
	} catch {
		return []
	}
	if (!parsed || !parsed.items || parsed.items.item === undefined) {
		return []
	}
	const item = parsed.items.item
	if (Array.isArray(item)) return item
	return [item]
}

/**
 * Merge multiple /collection responses (multi-user) into one flat list.
 * @param {{ data: string }[]} responses
 * @returns {object[]}
 */
export function mergeCollectionResponses(responses) {
	const items = []
	for (let i = 0; i < responses.length; i++) {
		const res = responses[i]
		if (!res || res.data == null) continue
		items.push(...parseCollectionItemsFromXmlString(typeof res.data === 'string' ? res.data : String(res.data)))
	}
	return items
}
